import React from 'react';
import BackComponent from "../components/BackComponent";
import TranslatedTextComponent from "../components/TranslatedTextComponent";
import "../style/faq.css";
import FaqNL from '../faqcontent/FaqNL';
import FaqFR from '../faqcontent/FaqFR';
import FaqEN from '../faqcontent/FaqEN';
import {connect} from "react-redux";

class FaqContainer extends React.Component {

	render() {
		let faqContent = null;
		if(this.props.language != null)
			switch (this.props.language.toUpperCase()){
				case 'NL':
					faqContent = <FaqNL/>;
					break;
				case 'FR':
					faqContent = <FaqFR/>;
					break;
				case 'EN':
					faqContent = <FaqEN/>;
					break;
				default:
					faqContent = null;
			}
		return(
			<div className="container-fluid faq">
				<BackComponent />

				<div className="faq-content">
					<div className="faq-title extraBold"><TranslatedTextComponent textKey="faq.title"/></div>
					{faqContent}
				</div>
			</div>);
	}

}

export default connect(
	(state) => {
		return {
			language: state.language.currentLanguage
		}
	}
)(FaqContainer)

